import styled, { css } from 'styled-components';
import { CLOSE_BUTTON_TOTAL_WIDTH } from '../constants';

export const Wrapper = styled.div<{ showStickyName: boolean }>`
  ${({ theme, showStickyName }) => css`
    position: sticky;
    top: ${theme.spacing.km6};
    z-index: 22;
    max-width: 100%;
    visibility: ${showStickyName ? 'visible' : 'hidden'};

    fuel-typography {
      white-space: nowrap;
    }

    fuel-typography,
    fuel-typography > p {
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
    }
  `}
`;

export const NameWrapper = styled.div<{ showCloseButton: boolean; isSmallProfile: boolean }>`
  ${({ showCloseButton, isSmallProfile, theme }) => css`
    padding: 0 ${theme.spacing.km8};
    position: absolute;
    display: flex;
    gap: ${theme.spacing.km2};
    align-items: center;
    height: 32px;
    justify-content: flex-start;
    max-width: 100%;

    ${showCloseButton &&
    css`
      max-width: calc(100% - ${CLOSE_BUTTON_TOTAL_WIDTH}px);
    `}

    ${isSmallProfile &&
    css`
      justify-content: center;
      width: 100%;
    `};
  `}
`;
